// Three-line mount of the platform's audit-log list route at /admin/audit.
//
// Customization is via metadata extension at the meta level — see
// `@podium/platform/routes#buildAuditTableMeta`. If gfo needed to add a
// "GFO-specific actor display name" column, it would `mergeTableMeta`
// with an override; nothing else changes.

import { auditListRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/audit')({
  ...auditListRoute,
  staticData: {
    nav: { label: 'Audit log', order: 30, group: 'Admin' },
    breadcrumb: 'Audit log',
  },
})
